import api from "@/api/axios";

export enum NotificationType {
  SYSTEM = "System",
  REFERAL = "Referal",
  VOUCHER = "Voucher",
  POINTS = "Points",
  MEMBERSHIP = "Membership",
  OTHER = "Other",
}

export enum NotificationAction {
  SYSTEM_SIGNUP_REWARD = "SYSTEM_SIGNUP_REWARD",
  REFERRAL_SIGNUP_REWARD = "REFERRAL_SIGNUP_REWARD",
  REFERRAL_TRANSACTION_REWARD = "REFERRAL_TRANSACTION_REWARD",
  VOUCHER_EXPIRING = "VOUCHER_EXPIRING",
  VOUCHER_NEW = "VOUCHER_NEW",
  POINTS_EXPIRING = "POINTS_EXPIRING",
  MEMBERSHIP_UPGRADE = "MEMBERSHIP_UPGRADE",
  MEMBERSHIP_DOWNGRADE = "MEMBERSHIP_DOWNGRADE",
  MEMBERSHIP_NEAR_UPGRADE = "MEMBERSHIP_NEAR_UPGRADE",
}

export interface NotificationDto {
  id: string;
  title: string;
  content: string | null;
  is_read: boolean;
  type: NotificationType;
  metadata?: Record<string, unknown>;
  created_at: string;
  read_at?: string;
}

export interface NotificationPageOptions {
  page?: number;
  limit?: number;
}

interface PaginationMeta {
  page: number;
  limit: number;
  total?: number;
  totalPages?: number;
  itemCount?: number;
  pageCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

interface PaginatedResponse<T> {
  data: T[];
  meta: PaginationMeta;
}

export const notificationService = {
  /**
   * Get paginated user notifications
   */
  async getNotifications(
    params: NotificationPageOptions,
  ): Promise<PaginatedResponse<NotificationDto>> {
    const response = await api.get<PaginatedResponse<NotificationDto>>(
      "/notifications",
      {
        params: {
          ...params,
          order: "DESC",
        },
      },
    );
    return response.data;
  },

  /**
   * Get user unread notifications count
   */
  async getUnreadCount(): Promise<number> {
    const response = await api.get<{ data: number }>(
      "/notifications/unread-count",
    );
    return response.data.data;
  },

  /**
   * Mark a notification as read
   */
  async markAsRead(id: string): Promise<void> {
    await api.patch(`/notifications/${id}/read`);
  },

  /**
   * Mark all notifications as read
   */
  async markAllAsRead(): Promise<void> {
    await api.post("/notifications/read-all");
  },
};
